import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './NovaVMModal.css';

const CONEXOES = [
  { value: 'internet', label: '🌐 Internet / IP válido' },
  { value: 'l2l', label: '🔗 L2L (interligação com o cliente)' },
  { value: 'ambos', label: '🌐+🔗 Internet + L2L' },
];
const STATUS_META = {
  pendente:  { label: '🟡 Pendente',  cls: 'pendente' },
  concluida: { label: '🟢 Concluída', cls: 'concluida' },
  recusada:  { label: '🔴 Recusada',  cls: 'recusada' },
};
const TIPO_LABEL = { cpu: '⚙ CPU', memoria: '🧠 Memória', disco: '💾 Disco', desativacao: '⏻ Desativação', nova_vm: '🖥 Nova VM' };
const fmtData = (iso) => iso ? new Date(iso).toLocaleString('pt-BR') : '';

export default function NovaVMModal({ onClose }) {
  const [cpu, setCpu] = useState('');
  const [memoria, setMemoria] = useState('');
  const [disco, setDisco] = useState('');
  const [conexao, setConexao] = useState('internet');
  const [observacao, setObservacao] = useState('');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState(null);
  const [minhas, setMinhas] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMinhas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/solicitacoes/minhas');
      setMinhas(res.data?.data || []);
    } catch (_) {}
    setLoading(false);
  }, []);

  useEffect(() => { fetchMinhas(); }, [fetchMinhas]);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  const handleSend = async () => {
    setSending(true);
    setMsg(null);
    try {
      await axios.post('/api/solicitacoes/', { cpu, memoria, disco, conexao, observacao });
      setMsg({ type: 'success', text: 'Solicitação enviada! A equipe será notificada.' });
      setCpu(''); setMemoria(''); setDisco(''); setObservacao('');
      await fetchMinhas();
    } catch (e) {
      setMsg({ type: 'error', text: e.response?.data?.error || 'Erro ao enviar solicitação.' });
    }
    setSending(false);
  };

  return (
    <div className="nvm-overlay" onClick={onClose}>
      <div className="nvm-modal" onClick={e => e.stopPropagation()}>
        <div className="nvm-header">
          <h2 className="nvm-title">🖥 Solicitar Nova VM</h2>
          <button type="button" className="nvm-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="nvm-form">
          <div className="nvm-field">
            <label>vCPUs</label>
            <input className="nvm-input" type="number" min="1" max="128" placeholder="Ex.: 4" value={cpu} onChange={e => setCpu(e.target.value)} disabled={sending} />
          </div>
          <div className="nvm-field">
            <label>Memória (GB)</label>
            <input className="nvm-input" type="number" min="1" max="1024" placeholder="Ex.: 8" value={memoria} onChange={e => setMemoria(e.target.value)} disabled={sending} />
          </div>
          <div className="nvm-field">
            <label>Disco (GB)</label>
            <input className="nvm-input" type="number" min="1" max="65536" placeholder="Ex.: 200" value={disco} onChange={e => setDisco(e.target.value)} disabled={sending} />
          </div>
          <div className="nvm-field">
            <label>Conexão</label>
            <select className="nvm-input" value={conexao} onChange={e => setConexao(e.target.value)} disabled={sending}>
              {CONEXOES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div className="nvm-field nvm-field-wide">
            <label>Observação</label>
            <input className="nvm-input" placeholder="Sistema operacional, finalidade, prazo... (opcional)" value={observacao} onChange={e => setObservacao(e.target.value)} disabled={sending} maxLength={255} />
          </div>
        </div>
        <div className="nvm-actions">
          <button type="button" className="nvm-send-btn" onClick={handleSend} disabled={sending}>
            {sending ? '...' : '📨 Enviar solicitação'}
          </button>
        </div>
        {msg && <div className={`nvm-msg ${msg.type}`}>{msg.text}</div>}

        <h3 className="nvm-section-title">Minhas solicitações</h3>
        {loading ? (
          <div className="nvm-loading">Carregando...</div>
        ) : minhas.length === 0 ? (
          <div className="nvm-empty">Você ainda não fez solicitações.</div>
        ) : (
          <div className="nvm-list">
            {minhas.map(s => {
              const st = STATUS_META[s.status] || { label: s.status, cls: '' };
              return (
                <div className="nvm-item" key={s.id}>
                  <div className="nvm-item-head">
                    <span className={`nvm-status ${st.cls}`}>{st.label}</span>
                    <span className="nvm-item-tipo">{TIPO_LABEL[s.tipo] || s.tipo}{s.vmid != null ? ` — VM ${s.vmid}` : ''}</span>
                    <span className="nvm-item-meta">{fmtData(s.created_at)}</span>
                  </div>
                  {s.valor && <div className="nvm-item-valor">{s.valor}</div>}
                  {s.observacao && <div className="nvm-item-obs">Obs.: {s.observacao}</div>}
                  {s.resposta && (
                    <div className="nvm-item-resposta">
                      <strong>Resposta</strong> ({fmtData(s.respondido_em)}): {s.resposta}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
